export const AB_TEST_CHECKOUT_WITHOUT_UPSELLING: number = 42069;
export const AB_TEST_PROGRESS_BAR_WITH_RECO: number = 303;
export const AB_TEST_DELIVERY_WITHOUT_ICONS: number = 312;
export const AB_TEST_UPSELLING_REDESIGN: number = 315;
export const AB_TEST_SERVICE_INFO_MODAL: number = 320;
export const AB_TEST_STICKY_BUTTONS: number = 319;
export const AB_TEST_FREE_DELIVERY_FOR_ONLINE_PAYMENTS: number = 391;
export const AB_TEST_DEFAULT_PAYMENT: number = 391;
